/* eslint-disable react/prop-types */
import { formatInfraDistance, truncateName } from "@/utils/locationFormatters.js";

/**
 * PublicInfrastructureSection - Renders the Public Infrastructure subsection
 * displaying nearby public services (City Hall, Fire Station, Post Office, Library).
 *
 * @param {Array<{ name: string, type: string, distance: number }>} items - Pre-selected infrastructure items (one per type, sorted by distance)
 * @param {boolean} hasError - Whether the infrastructure data fetch failed
 */
const PublicInfrastructureSection = ({ items = [], hasError = false }) => {
  if (hasError) {
    return (
      <div className="location-highlights__section location-highlights__infrastructure">
        <div className="location-highlights__section-header">
          <img
            src="/assets/images/pdp/publicInfra.png"
            alt=""
            aria-hidden="true"
            className="location-highlights__section-icon-img"
          />
          <h4 className="location-highlights__section-heading">Public Infrastructure</h4>
        </div>
        <p className="location-highlights__error-message">
          Public infrastructure information is currently unavailable
        </p>
      </div>
    );
  }

  if (!items || items.length === 0) {
    return (
      <div className="location-highlights__section location-highlights__infrastructure">
        <div className="location-highlights__section-header">
          <img
            src="/assets/images/pdp/publicInfra.png"
            alt=""
            aria-hidden="true"
            className="location-highlights__section-icon-img"
          />
          <h4 className="location-highlights__section-heading">Public Infrastructure</h4>
        </div>
        <p className="location-highlights__empty-message">
          No nearby public infrastructure found
        </p>
      </div>
    );
  }

  return (
    <div className="location-highlights__section location-highlights__infrastructure">
      <div className="location-highlights__section-header">
        <img
          src="/assets/images/pdp/publicInfra.png"
          alt=""
          aria-hidden="true"
          className="location-highlights__section-icon-img"
        />
        <h4 className="location-highlights__section-heading">Public Infrastructure</h4>
      </div>
      <ul className="location-highlights__list">
        {items.map((item, index) => (
          <li key={`${item.type}-${index}`} className="location-highlights__list-item">
            <div className="location-highlights__item-info">
              <span className="location-highlights__item-name">
                {truncateName(item.name)}
              </span>
              <span className="location-highlights__item-type">{item.type}</span>
            </div>
            <span className="location-highlights__item-distance">
              {formatInfraDistance(item.distance)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PublicInfrastructureSection;
